export default class EventEmitter {
    constructor() {
        this._events = {};
    }

    on(eventName, callback) {
        this._events[eventName] = this._events[eventName] || [];
        this._events[eventName].push(callback);
        return this;
    }

    once(event, callback) {
        const handler = function() {
            this.off(event, handler);
            callback.apply(this, arguments);
        }.bind(this);
        this.on(event, handler);
    };

    off(eventName, callback) {
        if (!eventName) {
            this._events = {};
            return this;
        }
        if (callback) {
            let events = this._events[eventName];
            if (!events || !events.length) {
                return this;
            }
            let index = events.indexOf(callback);
            if (~index) {
                events.splice(index, 1);
                return this;
            }
            if (!events.length)
                delete this._events[eventName];
            return this;
        }
        delete this._events[eventName];
        return this;
    }

    destroy() {
        this._events = null;
    }

    _fireEvent() {
        let eventName = arguments[0];
        let events = this._events ? this._events[eventName] : [];
        if (!events || !events.length) {
            return this;
        }
        let args = [].slice.call(arguments, 1);
        // snapshot to protect against handlers removing themselves (once) mid-iteration
        let snapshot = events.slice();
        for (let i = 0; i < snapshot.length; i++) {
            snapshot[i].apply(null, args);
        }
    }
}
